import { render, staticRenderFns } from "./DrugCombinationsReport.vue?vue&type=template&id=2276c6f0&"
import script from "./DrugCombinationsReport.vue?vue&type=script&lang=js&"
export * from "./DrugCombinationsReport.vue?vue&type=script&lang=js&"
import style0 from "./DrugCombinationsReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports